// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var Checkbox = require("@mui/material/Checkbox").default;
var Add = require("@mui/icons-material/Add").default;
var TextField = require("@mui/material/TextField").default;
var IconButton = require("@mui/material/IconButton").default;
var Delete = require("@mui/icons-material/Delete").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

function MM_cmp_web_src_settings(props) {
  var onRestoreDefaults = props.onRestoreDefaults;
  var onDelete = props.onDelete;
  var onTrustedChange = props.onTrustedChange;
  var onUrlChange = props.onUrlChange;
  var onAliasChange = props.onAliasChange;
  var onAdd = props.onAdd;
  var rndWebSrcSetting = function (src) {
    var msg = src.err;
    return JsxPPXReactSupport.createElementVariadicWithKey(src.id, Expln_React_Column.make, {
                children: Caml_option.some(null)
              }, [
                React.createElement(Expln_React_Row.make, {
                      children: Caml_option.some(null)
                    }, React.createElement(TextField, {
                          value: src.alias,
                          label: "Alias",
                          size: "small",
                          style: {
                            width: "150px"
                          },
                          onChange: (function (param) {
                              return Expln_React_common.evt2str((function (__x) {
                                            Curry._2(onAliasChange, src.id, __x);
                                          }), param);
                            })
                        }), React.createElement(TextField, {
                          value: src.url,
                          label: "URL",
                          size: "small",
                          style: {
                            width: "400px"
                          },
                          onChange: (function (param) {
                              return Expln_React_common.evt2str((function (__x) {
                                            Curry._2(onUrlChange, src.id, __x);
                                          }), param);
                            })
                        }), React.createElement(FormControlLabel, {
                          control: React.createElement(Checkbox, {
                                checked: src.trusted,
                                onChange: (function (param) {
                                    return Expln_React_common.evt2bool((function (__x) {
                                                  Curry._2(onTrustedChange, src.id, __x);
                                                }), param);
                                  })
                              }),
                          label: "Download without warning",
                          style: {
                            border: "solid 1px lightgrey",
                            marginTop: "-2px",
                            marginLeft: "2px",
                            paddingRight: "10px",
                            borderRadius: "7px"
                          }
                        }), JsxPPXReactSupport.createElementWithKey("delete-button", IconButton, {
                          onClick: (function (param) {
                              Curry._1(onDelete, src.id);
                            }),
                          children: Caml_option.some(React.createElement(Delete, {}))
                        })),
                msg !== undefined ? React.createElement("pre", {
                        style: {
                          color: "red"
                        }
                      }, msg) : null
              ]);
  };
  return React.createElement(Expln_React_Column.make, {
              style: {
                marginTop: "5px"
              },
              children: Caml_option.some(null)
            }, props.webSrcSettings.map(rndWebSrcSetting), React.createElement(Expln_React_Row.make, {
                  alignItems: "baseline",
                  children: Caml_option.some(null)
                }, JsxPPXReactSupport.createElementWithKey("add-button", IconButton, {
                      onClick: (function (param) {
                          Curry._1(onAdd, undefined);
                        }),
                      children: Caml_option.some(React.createElement(Add, {}))
                    }), React.createElement("span", {
                      style: {
                        color: "grey",
                        cursor: "pointer",
                        fontSize: "0.7em"
                      },
                      onClick: (function (param) {
                          Curry._1(onRestoreDefaults, undefined);
                        })
                    }, "Restore default URLs")));
}

var make = MM_cmp_web_src_settings;

exports.make = make;
/* react Not a pure module */
